import { mapState } from 'vuex';
import _ from 'lodash';
import { DoctorService } from '@/services/doctor.service';
export default {
  props: {
    type: {
      type: String,
      default: 'all',
      validator: value => ['all', 'active', 'inactive'].includes(value)
    }
  },
  data() {
    return {
      headers: [{
        key: 'photo',
        label: ''
      }, {
        key: 'name',
        label: 'Doctor'
      }, {
        key: 'coveredstate',
        label: 'State'
      }, {
        key: 'patientCount',
        label: 'Number of Patients'
      }, {
        key: 'active',
        label: 'Active'
      }, {
        key: 'active-permanent',
        label: 'Active - Permanent'
      }, {
        key: 'maxdailyaccept',
        label: 'Max Daily Accept'
      }, {
        key: 'tenweekfollowupversionname',
        label: '10W Follow up Version'
      }, {
        key: 'oneyearfollowupversionname',
        label: '1Y Follow up Version'
      }, {
        key: 'actions',
        label: 'Actions'
      }],
      items: [],
      patientCounts: new Map(),
      search: '',
      debouncedSearch: '',
      fetching: false,
      currentPage: 1,
      rowCount: 0,
      showEmptyResultsAlert: false
    };
  },
  computed: {
    ...mapState('tables', {
      currentPageStore: 'currentPage',
      currentTableRowCount: 'rowCount'
    })
  },
  watch: {
    search() {
      this.debouncer();
    },
    async debouncedSearch(val) {
      this.showEmptyResultsAlert = false;
      this.rowCount = 0;
      this.currentPage = 1;
      this.fetching = true;
      const {
        count
      } = await this.getDoctors({
        page: this.currentPage,
        search: val
      });
      this.fetching = false;
      if (count === 0) {
        this.showEmptyResultsAlert = true;
      }
    }
  },
  async mounted() {
    this.currentPage = 1;
    this.rowCount = 0;
    this.fetching = true;
    await this.getDoctors({
      page: this.currentPage,
      search: this.search
    });
    this.fetching = false;
  },
  methods: {
    async getDoctors({
      page = 1,
      search = ''
    }) {
      this.items = [];
      this.fetching = true;
      const {
        data
      } = await DoctorService.getDoctors({
        page,
        search,
        type: this.type
      });
      await Promise.all(data.items.map(async doctor => {
        const {
          data
        } = await DoctorService.getPatientCountByDoctor(doctor.id);
        this.patientCounts.set(doctor.id, data);
        if (doctor.coveredstate) {
          doctor.coveredstate.forEach(state => {
            const stateCount = data.find(count => count.state === state.state);
            state.active = stateCount ? stateCount.active : 0;
            state.active_permanent = stateCount ? stateCount.active_permanent : 0;
          });
        }
      }));
      this.fetching = false;
      this.items = data.items;
      this.patientCounts.forEach(count => {
        count.active = 0;
        count.active_permanent = 0;
        count.forEach(state => {
          count.active += Number(state.active || 0);
          count.active_permanent += Number(state.active_permanent || 0);
        });
      });
      this.items = this.items.map(doctor => {
        var _this$patientCounts$g, _this$patientCounts$g2;
        return {
          ...doctor,
          active: ((_this$patientCounts$g = this.patientCounts.get(doctor.id)) === null || _this$patientCounts$g === void 0 ? void 0 : _this$patientCounts$g.active) || 0,
          'active-permanent': ((_this$patientCounts$g2 = this.patientCounts.get(doctor.id)) === null || _this$patientCounts$g2 === void 0 ? void 0 : _this$patientCounts$g2.active_permanent) || 0
        };
      });
      this.rowCount = Number(data.count);
      this.$store.commit('tables/SET_ROW_COUNT', Number(data.count));
      return data;
    },
    // eslint-disable-next-line vue/no-unused-properties
    async getCurrentDoctorFilters() {
      const {
        data
      } = await DoctorService.getDoctors({
        page: this.currentPage,
        search: this.search,
        type: this.type
      });
      this.items = data.items;
      this.rowCount = Number(data.count);
    },
    debouncer: _.debounce(function () {
      this.debouncedSearch = this.search;
    }, 500),
    getTotalLimit(states) {
      let max = 0;
      for (const state of states) {
        max += Number(state.limit);
      }
      return max;
    },
    handlePaginationClick(event, pageNumber) {
      this.currentPage = pageNumber;
      this.getDoctors({
        page: pageNumber,
        search: this.search
      });
    },
    clearSearch() {
      this.search = '';
      this.$refs.searchInput.focus();
    }
  }
};